import { PageId } from '../../../types/idTypes';
import { PageClipboard } from './pageControlSlice';
import { RootState } from './store';

const selectActivePage = (state: RootState): PageId => state.pageControl.activePageId;
const selectPageClipboard = (state: RootState): PageClipboard[] => state.pageControl.pageClipboard;
const selectShowTagOverlay = (state: RootState): boolean => state.pageControl.showTagOverlay;
const selectIsAllFontsLoaded = (state: RootState): boolean => state.pageControl.isAllFontsLoaded;
const selectIsPageSizeMenuOpen = (state: RootState): boolean => state.pageControl.isPageSizeMenuOpen;
const selectIsPageNumbersMenuOpen = (state: RootState): boolean => state.pageControl.isPageNumbersMenuOpen;
const selectIsApplyToSelectedPage = (state: RootState): boolean => state.pageControl.isApplyToSelectedPage;

const selectIsPageOrientationDialogOpen = (state: RootState) => state.pageControl.isPageOrientationDialogOpen;
const selectPageOrientationDialogTemplateId = (state: RootState) => state.pageControl.pageOrientationDialogTemplateId;

export {
  selectActivePage,
  selectPageClipboard,
  selectShowTagOverlay,
  selectIsAllFontsLoaded,
  selectIsPageSizeMenuOpen,
  selectIsPageNumbersMenuOpen,
  selectIsApplyToSelectedPage,
  selectIsPageOrientationDialogOpen,
  selectPageOrientationDialogTemplateId,
};
